<template>
  <div id="application">
    <head>
      <link
        rel="stylesheet"
        href="https://pro.fontawesome.com/releases/v5.5.0/css/all.css"
        integrity="sha384-j8y0ITrvFafF4EkV1mPW0BKm6dp3c+J9Fky22Man50Ofxo2wNe5pT1oZejDH9/Dt"
        crossorigin="anonymous"
      >
      <meta
        name="viewport"
        content="width=device-width"
      >
    </head>
    <body>
      <div class="fixed-head">
        <philaHeader
          app-title="COVID-19 Employee screener"
        />
      </div>
      <main class="content">
        <div class="grid-container pbxl">
          <div class="app-container">
            <router-view />
          </div>
        </div>
      </main>

      <philaFooter />
    </body>
  </div>
</template>

<script>
import PhilaHeader from '@/components/PhilaHeader.vue';
import PhilaFooter from '@/components/PhilaFooter.vue';

export default {
  components: {
    PhilaHeader,
    PhilaFooter,
  },
  created() {
    if ('-ms-scroll-limit' in document.documentElement.style 
      && '-ms-ime-align' in document.documentElement.style) { // detect it's IE11
      window.addEventListener("hashchange", () => {
        let currentPath = window.location.hash.slice(1);
        if (this.$route.path !== currentPath) {
          this.$router.push(currentPath);
        }
      }, false);
    }
  },
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@600&display=swap" rel="stylesheet');

.desktop {
  @media screen and (max-width: 768px) { 
    display: none !important;
    &.app-divide {
      border-left: 0px !important;
    }
  }
}
.mobile {
  @media screen and (min-width: 768px) { 
    display: none !important;
  }
  &.fa-bars {
    color: #ffffff;
  }
}
.site-header {
  @media screen and (max-width: 768px) { 
    border-bottom: 4px solid #25CEF7;
  }
  .logo {
    min-width: 170px;
  }
  h1 {
    @media screen and (max-width: 768px) { 
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 22px;
    }
    @media screen and (max-width: 450px) { 
      font-size: 19px !important;
    }
  }
  p {
    display: none;
    margin-top: 2px;
    color: #FFFFFF;
    font-family: "Trebuchet MS";
    font-size: 9px;
    letter-spacing: 4.14px;
    line-height: 10px;
    margin-bottom: 0px;
    @media screen and (max-width: 768px) { 
      display: block;
    }
  }
}
.italic {
  font-style: italic;
}
.strong {
  font-weight: bold;
}
.info {
  display: block;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  
  .disclaimer {
    font-size: 0.75rem;
  }
  ol {
    padding: 22px;
  }
  .begin {
    display: block;
    margin-left: auto;
    margin-right: auto;
    background: #0F4D90;
    margin-top: 36px;
    padding: .1rem 6rem;
    color: #FFFFFF;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 40px;
    width: fit-content;
    max-width: 240px;
    text-align: center;
    &.completed {
      background: #CFCFCF;
      pointer-events: none;
      color: #A1A1A1;
    }
  }
}
.questionnaire {
  h3 {
    color: #000000;
    font-family: "Open Sans";
    font-size: 18px;
    letter-spacing: 0;
    line-height: 24px;
    margin-bottom: 14px;
    margin-top: 40px;
    .required {
      font-weight: bold;
      color: #0F4D90;
    }
  }
  .error-msg {
    display: none;
    i {
      font-family: "Font Awesome 5 Pro";
      font-style: normal;
      font-weight: 900;
    }
    &.error {
      max-width: 500px;
      font-weight: bold;
      background: #FCE5E6;
      color: #CF5B00;
      display: block;
      padding-left: 10px;
      margin: 10px 0px 20px 0px;
    }
  }
  .sub-label {
    display: block;
    margin-top: -10px;
  }
  input[type=radio]+label[for] {
    margin-top: 24px;
    color: #4A4A4A;
    font-family: "Open Sans";
    font-size: 16px;
    letter-spacing: 0;
    line-height: 24px;
    font-weight: normal;
    @media screen and (min-width: 768px) { 
      margin-left: 78px;
      margin-top: 16px;
    }
    &.error {
      color: #CF5B00;

    }
  }
  
  input[type=radio]+label:before {
    width: 15px;
    height: 15px;
    border-radius: 50%;
    left: -8px;
    position: relative;
    background-color: #ffffff;
    content: '';
    display: inline-block;
    visibility: visible;
    border: 1px solid #A1A1A1;
  }
  
  input[type=radio]+label.error:before {
    border: 1px solid #CF5B00;
  }

  input[type=radio]:checked+label::before {
    content: '';
    border: 1px #2176D2;
    box-shadow: inset 0px 0px 0px 4px #2176D2;
    
  }
  input[type=submit] {
    font-family: 'Montserrat', sans-serif;
    display: block;
    margin-left: auto;
    margin-right: auto;
    background: #0F4D90;
    margin-top: 36px;
    padding: .1rem 6rem;
    color: #FFFFFF;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 40px;
    border: none;
    &.incomplete {
      color: #A1A1A1;
      background: #CFCFCF;
    }
  }
  input[type=checkbox]+label[for] {
    width: 100%;
    margin: 0px 0px 24px 0px;
    color: #4A4A4A;
    font-family: "Open Sans";
    font-size: 16px;
    letter-spacing: 0;
    line-height: 24px;
    font-weight: normal;
    @media screen and (min-width: 768px) { 
      width: 50%;
      padding-left: 70px;
    }
    &[for="q4p0"] {
      width: 100%;
      margin-bottom: 0px;
    }
  }
  input[type=checkbox]:disabled+label[for] {
    opacity: 0.5;
  }
  hr {
    max-width: 800px;
    @media screen and (min-width: 768px) {
      margin-left: 70px;
    }
  }
  input[type=checkbox]+label::before {
    color: #A1A1A1;
    font-weight: 300;
  }
  input[type=checkbox]:checked+label::before {
    color: #2176D2;
    font-weight: 900;
  }
}
.result {
  .code-container {
    display: block;
    margin-right: auto;
    margin-left: auto;
    box-sizing: border-box;
    padding: 10px 0px 200px 0px;
    max-height: 204px;
    max-width: 255px;
    border: 1px solid #979797;
    @media screen and (min-width: 768px) {
      max-height: 204px;
      max-width: 311px;
    }
    span {
      font-family: "Open Sans";
      left: 37%;
      top: 23px;
      position: relative;
    }
    .code {
      display: block;
      text-align: center;
      margin: 0px auto;
      color: #4A4A4A;
      font-family: "Open Sans";
      font-size: 120px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 163px;
    }
  }
  .result-note {
    color: #4A4A4A;
    font-family: "Open Sans";
    letter-spacing: 0;
    display: block;
    width: fit-content;
    margin: 20px auto;
    max-width: 500px;
    text-align: center;
    &.result2,
    &.result3 {
      text-align: left;
    }
    a {
      -ms-word-break: break-all;
      word-break: break-all;
      word-break: break-word;
      -webkit-hyphens: auto;
      -moz-hyphens: auto;
      -ms-hyphens: auto;
      hyphens: auto;
    }
  }
}
.fixed-head {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
}
main {
  height: auto;
  margin-bottom: 4rem;
  position: relative;
  top: 80px;
  width: 100%;
  @media screen and (min-width: 768px) { 
    top: 80px;
  }
  &.content {
    top: 20px;
    padding: 0px 32px;
  }
}

p[dir=ltr]{
  margin-bottom:0;
}

section {
  width: 100%;
}

</style>